import React from 'react';

const TraitColorDropdown = ({ onSelect, variations, currentVariation, colorLabel }) => {
  if (!variations || variations.length < 1) {
      variations = [currentVariation];
  }

  if (!variations.some(variation => typeof variation.ColorTraitValue !== 'undefined' && variation.ColorTraitValue !== null)) {
    return null;
  }

  return (
    <div className="form-group">
      <div className='col-xs-12'>
        <label className={`color-trait-label`} htmlFor={'colorDropdown'}>{colorLabel}*</label>
        <select
            id={'colorDropdown'}
            className="form-control col-xs-12"
            value={currentVariation === null ? '' : currentVariation.ColorTraitValue}
            onChange={(e) => onSelect(e.target.value)}
        >
          {variations.map(
            (val, i) =>
            <option key={i} value={val.ColorTraitValue}>{val.ColorTraitValue}</option>)}
        </select>
      </div>
    </div>
  );
};

export default TraitColorDropdown;